<cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" tabindex="0" [expanded]="true">
  <section class="px-5" [formGroup]="licenseAgreementForm">
    <div class="relative flex items-center" (click)="accordionItem.toggle()">
      <svg-icon
        class="max-h-6 max-w-6"
        size="md"
        [key]="vm().form.controls.signer.valid ? 'px-24-agreement-icon-valid' : 'px-24-agreement-icon-invalid'"
      ></svg-icon>
      <span class="ml-2 text-[15px] font-medium leading-tight">{{ 'site_setup_contract_signer_details' | translate }}</span>
      <svg-icon
        class="absolute right-0 text-text-tertiary"
        [key]="accordionItem.expanded ? 'px-24-arrow-up' : 'px-24-arrow-down'"
      ></svg-icon>
    </div>
    <div formGroupName="signer" class="mt-5 grid gap-5" [style.display]="accordionItem.expanded ? '' : 'none'">
      @if (showSignerEmail) {
        <lib-input
          background="white"
          size="large"
          [label]="'site_setup_contract_signer_email' | translate"
          formControlName="signatoryEmail"
          [hint]="
            vm().form.controls.signer.controls.signatoryEmail.touched && vm().form.controls.signer.controls.signatoryEmail.invalid
              ? ('site_setup_form_required' | translate)
              : ''
          "
          [state]="
            vm().form.controls.signer.controls.signatoryEmail.touched && vm().form.controls.signer.controls.signatoryEmail.invalid
              ? 'error'
              : 'normal'
          "
        ></lib-input>
      }
      <div class="flex w-full gap-3">
        <lib-input
          background="white"
          class="!w-1/2"
          size="large"
          [label]="'site_setup_contract_signer_first_name' | translate"
          formControlName="signatoryFirstName"
          [hint]="
            this.vm().isFormSubmitted && vm().form.controls.signer.controls.signatoryFirstName.invalid
              ? ('site_setup_form_required' | translate)
              : ''
          "
          [state]="this.vm().isFormSubmitted && vm().form.controls.signer.controls.signatoryFirstName.invalid ? 'error' : 'normal'"
        ></lib-input>
        <lib-input
          background="white"
          class="!w-1/2"
          size="large"
          [label]="'site_setup_contract_signer_last_name' | translate"
          formControlName="signatoryLastName"
          [hint]="
            this.vm().isFormSubmitted && vm().form.controls.signer.controls.signatoryLastName.invalid
              ? ('site_setup_form_required' | translate)
              : ''
          "
          [state]="this.vm().isFormSubmitted && vm().form.controls.signer.controls.signatoryLastName.invalid ? 'error' : 'normal'"
        ></lib-input>
      </div>
      @if (showAuthorizedCheckbox() && authorizedCheckboxFormControl) {
        <div class="mt-10 flex items-center">
          <lib-checkbox
            [formControl]="authorizedCheckboxFormControl"
            [variant]="vm().isFormSubmitted && authorizedCheckboxFormControl.invalid ? 'error' : 'primary'"
          ></lib-checkbox>
          <p
            class="ml-2 text-h4 font-light"
            [ngClass]="{
              'text-states-deep-red': vm().isFormSubmitted && authorizedCheckboxFormControl.invalid
            }"
          >
            {{ 'site_setup_contract_confirm_authorized_sign' | translate }}
          </p>
          <svg-icon size="sm" class="ml-2" [key]="'px-16-info'" [libUiTooltip]="checkboxTooltip" tooltipPosition="top"></svg-icon>
          <ng-template #checkboxTooltip>
            <div class="typo-h5-book whitespace-pre-wrap">
              {{ 'site_setup_form_signer_tooltip' | translate }}
            </div>
          </ng-template>
        </div>
      }
    </div>
  </section>
</cdk-accordion-item>
